import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from "underscore";

import SearchResultItem from './SearchResultItem'
import LanguageStringResolver from '../fields/language/LanguageStringResolver';

import MANAGED_UX_FORMS_CONTROLLER from '../../controllers/managedUxForms';
import Logger, { LOG_LEVELS } from '../../utils/logger';
import ReadOnlyWrapper from '../authorization/ReadOnlyWrapper';

const FORM_NAME = 'TRANSACTION_SEARCH_RESULTS_FORM';
const log = new Logger(FORM_NAME, LOG_LEVELS.DEBUG);

export class TransactionSearchResultsForm extends Component {

  constructor(props) {
    super(props);
    this.currentIndex = props.docsPerPage;
    this.page = "page ";
    this.pageNumber = 1;
  }

  render() {
    log.debug('render: ', this.props);
    if (this.props.doResetPaging === 1) {
      this.resetPaging();
    }
    const transactionPage = this.props.transactionPage;
    const fieldValues = this.props.formData && this.props.formData.fieldValues;
    const transactionIDCount = this.getNumberOfTransactionDetailIDs();
    const selectedCount = (fieldValues && this.getSelectedIds().length) || 0;
    const enableNextButton = (this.currentIndex < transactionIDCount);
    const enablePreviousButton = (this.currentIndex > this.props.docsPerPage);
    const numberOfPages = this.getNumberOfPages(transactionIDCount);
    log.debug('render: transactionPage', transactionPage);
    log.debug('render: fieldValues', fieldValues);

    return (
      <ReadOnlyWrapper>
        <div>
          {
            (() => {
              if (!transactionPage || transactionPage.length <= 0) {
                return (
                  <SearchResultItem
                    none={true}
                    allowSelection={this.props.allowActions}
                    disableLinks={this.props.disableLinks}
                    formInitialising={!fieldValues}
                  />);
              }
              {
                if (!transactionPage || transactionPage.length > 0) {
                  return (
                    <div>
                      <div className="mt10 mb10">
                        <div>
                          <hr />
                          <SearchResultItem
                            header={true}
                            allowSelection={this.props.allowActions}
                            disableLinks={this.props.disableLinks}
                            formInitialising={!fieldValues}
                            onSelect={this.onSelectAll.bind(this)}
                            selected={fieldValues && fieldValues['_all']}
                          />
                          <hr />
                        </div>
                        <div>
                          {
                            (() => {

                              return transactionPage.map((transaction, index) => {
                                return (
                                  <div>
                                    <SearchResultItem
                                      key={index}
                                      allowSelection={this.props.allowActions}
                                      disableLinks={this.props.disableLinks}
                                      formInitialising={!fieldValues}
                                      transaction={transaction}
                                      onSelect={this.onSelectTransactionFactory(transaction.id).bind(this)}
                                      selected={fieldValues && fieldValues[transaction.id + '']}
                                      onLineAction={this.onLineAction.bind(this)}
                                      resetAllActionToDefault={this.props.resetAllActionToDefault}
                                    />
                                    <hr />
                                  </div>
                                );
                              })
                            })()
                          }
                        </div>
                        <div className="ReactTable">
                          <div className="pagination-bottom">
                            <div className="-pagination">
                              <s-container class="full-width">
                                <s-row>
                                  <s-col span="2" class="pb0">
                                    {/* Future 1-10 of 999 functionality will go here */}
                                  </s-col>
                                  <s-col span="8" class="center p0">
                                    <div className="-previous mr20">
                                      <button
                                        className="-btn"
                                        disabled={(enablePreviousButton ? '' : 'disabled')}
                                        onClick={this.onRequestPreviousPage.bind(this)}
                                        excludeFromReadonly={true}
                                      >
                                        <s-icon name="chevron-down"></s-icon> <LanguageStringResolver string={'transactionSearchPagingLabel_Previous'} />
                                      </button>
                                    </div>
                                    <span className="-pageInfo relative">
                                      {(transactionIDCount > 0) ? this.page + this.pageNumber + "/" + numberOfPages : ""}
                                    </span>
                                    <div className="-next ml20">
                                      <button
                                        className="-btn"
                                        disabled={(enableNextButton ? '' : 'disabled')}
                                        onClick={this.onRequestNextPage.bind(this)}
                                        excludeFromReadonly={true}
                                      >
                                        <LanguageStringResolver string={'transactionSearchPagingLabel_Next'} /> <s-icon name="chevron-down"></s-icon>
                                      </button>
                                    </div>
                                  </s-col>
                                  <s-col span="2" class="pr0 pb0">
                                    {/* Show page size options functionality will go here */}
                                  </s-col>
                                </s-row>
                              </s-container>
                            </div>
                          </div>
                        </div>
                      </div>
                      {
                        this.props.allowActions ?
                          (
                            <div>
                              <button
                                disabled={selectedCount === 0 ? true : ''}
                                className={'secondary mt20 mb20'}
                                onClick={this.onRequestActionFactory('delete').bind(this)}
                              >
                                <LanguageStringResolver string={'transactionSearchActionLabel_Delete'} />
                              </button>
                              <button
                                disabled={selectedCount === 0 ? true : ''}
                                className={'secondary mt20 mb20'}
                                onClick={this.onRequestActionFactory('forceToError').bind(this)}
                              >
                                <LanguageStringResolver string={'transactionSearchActionLabel_ForceToError'} />
                              </button>
                              <button
                                disabled={selectedCount === 0 ? true : ''}
                                className={'secondary mt20 mb20'}
                                onClick={this.onRequestActionFactory('redeliver').bind(this)}
                              >
                                <LanguageStringResolver string={'transactionSearchActionLabel_Redeliver'} />
                              </button>
                              <button
                                disabled={selectedCount === 0 ? true : ''}
                                className={'secondary mt20 mb20'}
                                onClick={this.onRequestActionFactory('export').bind(this)}
                                excludeFromReadonly={true}
                              >
                                <LanguageStringResolver string={'transactionSearchActionLabel_Export'} />
                              </button>
                            </div>
                          ) :
                          (
                            <div></div>
                          )
                      }
                    </div>
                  )
                }
              }
            })()
          }
        </div>
      </ReadOnlyWrapper>
    )
  }

  getNumberOfTransactionDetailIDs() {
    if (this.props.transactionIDs === undefined) {
      return 0;
    }
    let totalIDs = 0;
    totalIDs = Array.isArray(this.props.transactionIDs.invoices) ? totalIDs + this.props.transactionIDs.invoices.length : totalIDs;
    totalIDs = Array.isArray(this.props.transactionIDs.warnings) ? totalIDs + this.props.transactionIDs.warnings.length : totalIDs;
    totalIDs = Array.isArray(this.props.transactionIDs.errors) ? totalIDs + this.props.transactionIDs.errors.length : totalIDs;
    totalIDs = Array.isArray(this.props.transactionIDs.deleteLogs) ? totalIDs + this.props.transactionIDs.deleteLogs.length : totalIDs;
    totalIDs = Array.isArray(this.props.transactionIDs.documentsOnHold) ? totalIDs + this.props.transactionIDs.documentsOnHold.length : totalIDs;
    totalIDs = Array.isArray(this.props.transactionIDs.documentsInInbox) ? totalIDs + this.props.transactionIDs.documentsInInbox.length : totalIDs;
    return totalIDs;
  }

  getNumberOfPages(transactionIDCount) {
    if (this.props.docsPerPage > 0) {
      return Math.ceil(transactionIDCount / this.props.docsPerPage);
    } else {
      return 0;
    }
  }

  resetPaging() {
    this.currentIndex = this.props.docsPerPage;
    this.pageNumber = 1;
  }

  onSelectAll(select) {
    if (!this.props.allowActions) {
      return;
    }
    const list = this.props.transactionPage;
    log.debug('onSelectAll(): ', select, list);
    if (!list) {
      return;
    }
    const fieldValues = list.reduce((values, transaction) => {
      if (transaction.id === null) {
        return values;
      }
      values[transaction.id + ''] = select;
      return values;
    }, { '_all': select });
    this.props.doInitialiseForm(fieldValues);
  }

  onSelectTransactionFactory(documentId) {
    return (select) => {
      if (!this.props.allowActions) {
        return;
      }
      log.debug('onSelectTransactionFactory(%s): ', documentId, select);
      this.props.onFieldChange(documentId + '', select);
    }
  }

  getSelectedIds() {
    const transactionList = this.props.transactionPage;
    const fieldValues = this.props.formData && this.props.formData.fieldValues;
    log.debug('getSelectedIds(): transactionList: ', transactionList);
    log.debug('getSelectedIds(): fieldValues: ', fieldValues);

    const transactionIds = _.reduce(transactionList, (list, value, id) => {
      if (fieldValues[value.id + '']) list.push(value.id);
      return list;
    }, []);
    log.debug('getSelectedIds(): transactionIds: ', transactionIds);

    return transactionIds;

  }

  onRequestActionFactory(action) {
    return (evt) => {
      if (!this.props.allowActions) {
        return;
      }
      const transactionIdsToAction = this.getSelectedIds();
      log.debug('onRequestActionFactory(%s): transactionIdsToAction: ', action, transactionIdsToAction);
      this.props.onRequestAction(action, transactionIdsToAction);
      this.props.doFormSubmitted();
    }
  }

  onRequestPreviousPage() {
    if ((this.props.transactionIDs !== undefined) && (this.currentIndex > this.props.docsPerPage)) {
      let startIndex = this.currentIndex - (2 * this.props.docsPerPage);
      this.pageNumber -= 1;
      if (startIndex >= 0) {
        this.currentIndex = this.currentIndex - this.props.docsPerPage;
        this.props.doSearchPage(this.props.transactionIDs, startIndex, this.props.docsPerPage);
      } else {
        this.currentIndex = this.props.docsPerPage;
        this.props.doSearchPage(this.props.transactionIDs, 0, this.props.docsPerPage);
      }
      this.props.doInitialiseForm({});
    }
  }

  onRequestNextPage() {
    if ((this.props.transactionIDs !== undefined) && (this.currentIndex < this.getNumberOfTransactionDetailIDs() - 1)) {
      let startIndex = this.currentIndex;
      this.currentIndex = this.currentIndex + this.props.docsPerPage;
      this.pageNumber += 1;
      this.props.doSearchPage(this.props.transactionIDs, startIndex, this.props.docsPerPage);
      this.props.doInitialiseForm({});
    }
  }

  onLineAction(id, evt) {
    const action = evt?.detail?.item?.value;
    log.debug('onLineAction ', action);
    log.debug('onLineAction ', id);

    if (!action || action === 'Select action' || action === '') {
      return;
    }

    this.props.onRequestAction(action, [id]);
    this.props.doFormSubmitted();
  }

  componentWillUnmount() {
    log.debug('componentWillMount(): ', this.props);
    if (this.props.allowActions) {
      this.props.doDestroyForm();
    }
  }

  UNSAFE_componentWillMount() {
    log.debug('componentWillMount(): ', this.props);
    if (this.props.allowActions) {
      this.onSelectAll(this.props.initialSelection);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.allowActions
      && this.props.transactionPage
      && this.props.transactionPage !== prevProps.transactionPage
      && !(this.props.formData && this.props.formData.fieldValues)) {
      this.onSelectAll(this.props.initialSelection);
    }
  }

}

function mapStateToProps(state, props) {
  log.debug('mapStateToProps(): state & props', state, props);
  return {
    formData: (state.managedUxForms && state.managedUxForms.forms[FORM_NAME]),
  };
}

function mapDispatchersToProps(dispatch) {
  return {
    doInitialiseForm: (initialValues) => {
      log.debug('doInitialiseForm(): ', initialValues);
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doInitialiseForm(FORM_NAME, initialValues));
    },
    doResetForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doResetFormFieldsToInitialValues(FORM_NAME));
    },
    doClearForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doClearFormFields(FORM_NAME));
    },
    onFieldChange: (fieldName, value) => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormFieldChange(FORM_NAME, fieldName, value));
    },
    doFormSubmitted: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doFormSubmitted(FORM_NAME));
    },
    doDestroyForm: () => {
      dispatch(MANAGED_UX_FORMS_CONTROLLER.doRemoveForm(FORM_NAME));
    }
  }
}


TransactionSearchResultsForm.defaultProps = {
  initialSelection: false,
  allowActions: true,
  disableLinks: false,
  onRequestAction: () => { },
  resetAllActionToDefault: false
};

// Wrap the component to inject state into it
export default connect(mapStateToProps, mapDispatchersToProps)(TransactionSearchResultsForm);
